export const companySideAreaCalls = (company) => {
	const data = (company.calls ?? []).map((call) => ({
		id: call.id,
		type: 'link',
		payload: {
			links: [
				{
					id: `${call.id}-link`,
					label: call.externalId,
					link: {
						to: '/',
					},
				},
			],
			direction: 'column',
		},
	}));

	if (!data.length) return null;

	return {
		id: 'calls',
		label: 'Звонки',
		items: [
			{
				id: 'calls-list',
				data: {
					calls: data,
				},
			},
		],
	};
};
